"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YellowBackgroundWithGhostIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const YellowBackgroundWithGhostIcon_module_css_1 = __importDefault(require("./YellowBackgroundWithGhostIcon.module.css"));
const GhostIcon_1 = require("../../../icons/GhostIcon");
/**
 * Yellow page background with centered Ghost icon
 */
function YellowBackgroundWithGhostIcon({ size }) {
    const width = GhostIcon_1.GhostIconTypeToSize[size].width;
    const height = GhostIcon_1.GhostIconTypeToSize[size].height;
    return ((0, jsx_runtime_1.jsx)("div", { className: YellowBackgroundWithGhostIcon_module_css_1.default.container, children: (0, jsx_runtime_1.jsx)(GhostIcon_1.GhostIconFilled, { width: width, height: height }) }));
}
exports.YellowBackgroundWithGhostIcon = YellowBackgroundWithGhostIcon;
//# sourceMappingURL=index.js.map